/** @format — info.banner AG-UI component */

import React from "react";
import { Info, AlertTriangle, CheckCircle2 } from "lucide-react";

const TONES = {
  neutral: {
    bg: "bg-[#F9FAFB]",
    border: "border-[#E4E7EC]",
    text: "text-[#344054]",
    Icon: Info,
  },
  warning: {
    bg: "bg-[#FFFAEB]",
    border: "border-[#FEC84B]",
    text: "text-[#B54708]",
    Icon: AlertTriangle,
  },
  success: {
    bg: "bg-[#ECFDF3]",
    border: "border-[#6CE9A6]",
    text: "text-[#027A48]",
    Icon: CheckCircle2,
  },
};

export default function InfoBannerCard({ props = {} }) {
  const tone = TONES[props.tone] ?? TONES.neutral;
  const { Icon } = tone;

  return (
    <div
      className={`flex items-start gap-2 rounded-lg border px-4 py-3 ${tone.bg} ${tone.border}`}
    >
      <Icon className={`w-4 h-4 mt-0.5 flex-shrink-0 ${tone.text}`} aria-hidden />
      <p className={`text-[13px] leading-relaxed ${tone.text}`}>{props.text}</p>
    </div>
  );
}
